<template>
  <div class="item-request-modal-bg" v-if="board.requestRoom.show" @click="bgclick()">
    <form @keyup.esc="close()" tabindex="0" >
      <v-layout id='item_request_modal' class='item-request-modal' v-resize="onResize" :style="{'left': left, 'top': top}">
        <div class="request-view-wrap">
          <v-flex shrink>
            <div class="view-title-bar">
              <v-layout class="column" fill-height>
                <v-flex glow>
                  <v-layout align-center justify-space-between row fill-height>
                    <!-- 좌측 -->
                    <v-flex class="title-bar-item shrink">
                      <v-btn fit icon class="hidden-md-and-up" @click="close()"><v-icon>keyboard_arrow_left</v-icon></v-btn>
                    </v-flex>
                    <v-flex class="title-bar-item text-xs-center shrink">
                      {{getStep()}}%
                    </v-flex>
                    <v-flex class="title-bar-item shrink">
                      <v-btn fit icon class="hidden-sm-and-down" @click="close()"><v-icon>close</v-icon></v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink>
                  <v-progress-linear
                    :value="getStep()"
                    height="5"
                    class="receipt-modal-progress"
                  ></v-progress-linear>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
          <div class="view-detail">
            <div class="title-area">
              <div class="bg-img layout align-center">
                <img :src="`${$utile.getStaticUrl()}/modal/request-room-bg-1.jpg`" >
                <v-layout align-center justify-center class="bg-cover"><!--justify-center-->
                  <div class="title-text"><v-icon color="#005FFF">search</v-icon> 하우스북, 내 방좀 찾아줘!</div>
                </v-layout>
              </div>
            </div>
            <div class="form-padding">
              <div class="form-cover">
                <!-- 1step 가격 -->
                <div v-if="step === 1">
                  <div class="form-title">
                    원하시는 가격대를 알려주세요!
                  </div>
                  <div class="form-area">
                    <v-layout class="column form-box">
                      <v-radio-group v-model="form.saleType" class="radio-group pa-0 ma-0">
                        <div class="form-item py-4">
                          <v-radio color="primary" label="월세" value="1"></v-radio>
                          <div class="filter-body" v-if="form.saleType == 1">
                            <div class="line"></div>
                            <div class="filter-slider">
                              <div class="filter-title">
                                보증금 {{printDeposit}}
                              </div>
                              <v-flex style="position: relative;">
                                <v-range-slider
                                  v-model="form.depositStep"
                                  :max="34"
                                  :min="0"
                                  style="padding:0 10px;"
                                ></v-range-slider>
                                <v-flex class="filter-slider-guide">
                                  <span style="float: left; margin-left:5px;">0</span>
                                  <span style="float: right; margin-right:-8px;">무제한</span>
                                </v-flex>
                              </v-flex>
                            </div>
                            <div class="line" style="margin-top:32px;"></div>
                            <div class="filter-slider">
                              <div class="filter-title">
                                월세 {{printMonthly}}
                              </div>
                              <v-flex style="position: relative;">
                                <v-range-slider
                                  v-model="form.monthlyStep"
                                  :max="30"
                                  :min="0"
                                  style="padding:0 10px;"
                                ></v-range-slider>
                                <v-flex class="filter-slider-guide">
                                  <span style="float: left; margin-left:5px;">0</span>
                                  <span style="float: right; margin-right:-8px;">무제한</span>
                                </v-flex>
                              </v-flex>
                            </div>
                          </div>
                        </div>
                        <div class="form-item py-4">
                          <v-radio color="primary" label="전세" value="2"></v-radio>
                          <div class="filter-body" v-if="form.saleType == 2">
                            <div class="line"></div>
                            <div class="filter-slider">
                              <div class="filter-title">
                                전세 {{printRental}}
                              </div>
                              <v-flex style="position: relative;">
                                <v-range-slider
                                  v-model="form.rentalStep"
                                  :max="44"
                                  :min="0"
                                  style="padding:0 10px;"
                                ></v-range-slider>
                                <v-flex class="filter-slider-guide">
                                  <span style="float: left; margin-left:5px;">0</span>
                                  <span style="float: right; margin-right:-8px;">무제한</span>
                                </v-flex>
                              </v-flex>
                            </div>
                          </div>
                        </div>
                        <div class="form-item py-4">
                          <v-radio color="primary" label="매매" value="3"></v-radio>
                          <div class="filter-body" v-if="form.saleType == 3">
                            <div class="line"></div>
                            <div class="filter-slider">
                              <div class="filter-title">
                                매매가 {{printSalePrice}}
                              </div>
                              <v-flex style="position: relative;">
                                <v-range-slider
                                  v-model="form.salePriceStep"
                                  :max="25"
                                  :min="0"
                                  style="padding:0 10px;"
                                ></v-range-slider>
                                <v-flex class="filter-slider-guide">
                                  <span style="float: left; margin-left:5px;">0</span>
                                  <span style="float: right; margin-right:-8px;">무제한</span>
                                </v-flex>
                              </v-flex>
                            </div>
                          </div>
                        </div>
                      </v-radio-group>
                    </v-layout>
                  </div>
                </div>
                <!-- 2step 방유형 -->
                <div v-if="step === 2">
                  <div class="form-title">
                    어떤 구조의 방을 찾으세요?
                  </div>
                  <div class="form-area">
                    <v-layout class="column form-box">
                      <v-radio-group v-model="form.roomType" class="radio-group pa-0 ma-0">
                        <div class="form-item py-4">
                          <v-radio color="primary" label="방 1개 (원룸)" value="1"></v-radio>
                        </div>
                        <div class="form-item py-4">
                          <v-radio color="primary" label="방 1.5개 (1.5룸)" value="2"></v-radio>
                        </div>
                        <div class="form-item py-4">
                          <v-radio color="primary" label="방 2개 (투룸)" value="3"></v-radio>
                        </div>
                        <div class="form-item py-4">
                          <v-radio color="primary" label="방 3개 (쓰리룸)" value="4"></v-radio>
                        </div>
                        <div class="form-item py-4">
                          <v-radio color="primary" label="방 4개 (포룸)" value="5"></v-radio>
                        </div>
                        <div class="form-item py-4">
                          <v-radio color="primary" label="직접입력" value="6"></v-radio>
                          <div v-if="form.roomType == 6">
                            <div class="line"></div>
                            <v-text-field
                              v-model="form.roomMemo"
                              label="원하시는 조건을 입력해주세요."
                            ></v-text-field>
                          </div>
                        </div>
                      </v-radio-group>
                    </v-layout>
                  </div>
                </div>
                <!-- 3step 날짜 -->
                <div v-if="step === 3">
                  <div class="form-title">
                    원하시는 입주 날짜가 있으신가요?
                  </div>
                  <div class="form-area">
                    <v-layout class="column form-box">
                      <v-radio-group v-model="form.dateType" class="radio-group pa-0 ma-0">
                        <div class="form-item py-4">
                          <v-radio color="primary" label="상담 후 결정할래요" value="1"></v-radio>
                        </div>
                        <div class="form-item py-4">
                          <v-radio color="primary" label="가능한 빨리하고싶어요" value="2"></v-radio>
                        </div>
                        <div class="form-item py-4">
                          <v-radio color="primary" label="원하는 날짜가 있어요" value="3"></v-radio>
                          <div v-if="form.dateType == 3">
                            <div class="line"></div>
                            <v-date-picker
                              v-model="form.datePicker"
                              :first-day-of-week="0"
                              locale="kr"
                              full-width="true"
                              color="primary"
                            ></v-date-picker>
                          </div>
                        </div>
                        <div class="form-item py-4">
                          <v-radio color="primary" label="직접입력" value="4"></v-radio>
                          <div v-if="form.dateType == 4">
                            <div class="line"></div>
                            <v-text-field
                              v-model="form.dateMemo"
                              label="원하시는 조건을 입력해주세요."
                            ></v-text-field>
                          </div>
                        </div>
                      </v-radio-group>
                    </v-layout>
                  </div>
                </div>
                <!-- 4step 지역 -->
                <div v-if="step === 4">
                  <div class="form-title">
                    원하시는 지역이 있으신가요?
                  </div>
                  <div class="form-area">
                    <v-layout class="column form-box">
                      <v-radio-group v-model="form.locType" class="radio-group pa-0 ma-0">
                        <div class="form-item py-4">
                          <v-radio color="primary" label="지하철역 인근" value="1"></v-radio>
                          <div v-if="form.locType == 1" style="position: relative;">
                            <div class="line"></div>
                            <v-text-field
                              v-model="form.locSubway"
                              label="지하철역을 입력해주세요."
                            ></v-text-field>
                            <div v-if="search.show" id="subway_list_box" class="subway-list-box">
                              <div v-for="(item, index) in search.data" :key="index" @click="subwayListClick(item.subwayName)" class="item">
                                {{item.subwayName}}
                              </div>
                            </div>
                            <v-select
                              v-model="form.locRange"
                              :items="['5분거리', '10분거리', '15분거리', '20분거리', '상관없음']"
                              label="지하철역 인근 몇분 거리까지 생각하세요?"
                              class="mt-3 mb-2"
                            ></v-select>
                          </div>
                        </div>
                        <div class="form-item py-4">
                          <v-radio color="primary" label="직접입력" value="2"></v-radio>
                          <div v-if="form.locType == 2">
                            <div class="line"></div>
                            <v-text-field
                              v-model="form.locMemo"
                              label="원하시는 조건을 입력해주세요."
                            ></v-text-field>
                          </div>
                        </div>
                      </v-radio-group>
                    </v-layout>
                  </div>
                </div>
                <!-- 5step 상세 -->
                <div v-if="step === 5">
                  <div class="form-title">
                    연락처와 남기실 말씀을 입력해주세요!
                  </div>
                  <div class="form-area">
                    <v-layout class="column form-box">
                      <v-flex class="form-item">
                        <v-text-field
                          v-model="form.hp"
                          :mask="'###-####-####'"
                          label="연락처를 입력해주세요."></v-text-field>
                      </v-flex>
                      <v-flex class="form-item">
                        <v-textarea
                          v-model="form.memo"
                          label="남기실 말씀을 입력해주세요."
                          hint="최대 255자까지 입력이 가능합니다."
                          counter="255"
                        ></v-textarea>
                      </v-flex>
                      <v-flex class="form-item">
                        <v-checkbox
                          v-model="form.approval"
                          :rules="[v => !!v || '']"
                          label=""
                          color="title_color"
                        >
                          <template slot="append"><span style="color: rgba(0,0,0,.54) !important; white-space: nowrap; line-height: 1; padding-top:3px;"><a href="/bbs/content.php?co_id=privacy" target="_blank" style="line-height: 1;">개인정보처리방침</a>, <a href="/bbs/content.php?co_id=provision" target="_blank">이용약관</a> 동의</span></template>
                        </v-checkbox>
                      </v-flex>
                    </v-layout>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-info">
              <div class="info-title">
                찾을 필요없는, 방 매칭 서비스
              </div>
              <div class="info-text">
                일일히 방찾기 지치시죠?<br>
                방은 수없이 많은데 내 조건에 꼭 맞는 방은 어디에 숨어있는지.. 막막하신가요?<br>
                발품은 저희가 팔아 드리겠습니다. 필요하신 조건만 입력하면 내방이 한방에 딱!
              </div>
              <div class="info-title">
                하우스북은?
              </div>
              <div class="info-text">
                어딜봐도 허위매물에 지치고 실망하신적 있으시죠? 도대체 방은 어디서 봐야할지 막막하셨던 분들을에게 "하우스북"이 100% 실제 매물과 다양한 팁, 그리고 조건별 핫딜까지!<br>
                여러분의 방을 책임지겠습니다!
              </div>
            </div>
          </div>
          <!-- 하단 바 -->
          <v-flex shrink>
            <div class="view-bottom-bar">
              <v-layout class="bar-wrap" justify-center fill-height>
                <v-flex class="item prev" v-if="step > 1" @click="prevPage()"><span>이전</span></v-flex> <!-- /*border-right:solid 1px #69a6ff;*/ -->
                <v-flex :class="`item ${(isPass? '' : 'disable')}`"  @click="nextPage()">
                  <v-progress-circular
                    indeterminate
                    :size="25"
                    :width="3"
                    color="primary"
                    v-if="submitLoading"
                  ></v-progress-circular>
                  <span v-if="!submitLoading">{{(step === maxStep)? '접수하기' : '다음'}}</span>
                </v-flex>
              </v-layout>
            </div>
          </v-flex>
        </div>
      </v-layout>
    </form>
  </div>
</template>

<script>
// import Config from '@/config'
import { mapState, mapActions } from 'vuex'
import EventBus from '@/utile/eventBus'
import axios from 'axios'
// import qs from 'qs'

export default {
  name: 'RequestRoom',
  data: () => ({
    submitLoading: false,
    left: 0,
    top: 0,
    step: 1,
    maxStep: 5,
    // 보/전 37개 옵션 0~36
    depositStepText: ['0 원', '100만 원', '200만 원', '300만 원', '400만 원', '500만 원', '1천만 원', '1.5천만 원', '2천만 원', '2.5천만 원', '3천만 원', '3.5천만 원', '4천만 원', '4.5천만 원', '5천만 원', '6천만 원', '7천만 원', '8천만 원', '9천만 원', '1억', '1.1억 원', '1.2억 원', '1.3억 원', '1.4억 원', '1.5억 원', '1.6억 원', '1.7억 원', '1.8억 원', '1.9억 원', '2억 원', '2.5억 원', '3억 원', '3.5억 원', '4억 원', '무제한'],
    // 월세 30개 옵션 0~29
    monthlyStepText: ['0 원', '5만 원', '10만 원', '15만 원', '20만 원', '25만 원', '30만 원', '35만 원', '40만 원', '45만 원', '50만 원', '55만 원', '60만 원', '65만 원', '70만 원', '80만 원', '90만 원', '100만 원', '110만 원', '120만 원', '130만 원', '140만 원', '150만 원', '160만 원', '170만 원', '180만 원', '190만 원', '200만 원', '250만 원', '300만 원', '무제한'],
    // 전세
    rentalStepText: ['0 원', '100만 원', '200만 원', '300만 원', '400만 원', '500만 원', '1천만 원', '1.5천만 원', '2천만 원', '2.5천만 원', '3천만 원', '3.5천만 원', '4천만 원', '4.5천만 원', '5천만 원', '6천만 원', '7천만 원', '8천만 원', '9천만 원', '1억', '1.1억 원', '1.2억 원', '1.3억 원', '1.4억 원', '1.5억 원', '1.6억 원', '1.7억 원', '1.8억 원', '1.9억 원', '2억 원', '2.5억 원', '3억 원', '3.5억 원', '4억 원', '4.5억 원', '5억 원', '5.5억 원', '6억 원', '6.5억 원', '7억 원', '7.5억 원', '8억 원', '8.5억 원', '9억 원', '무제한'],
    // 매매 26개 0~25
    salePriceStepText: ['0 원', '5천만 원', '1억 원', '1.5억 원', '2억 원', '2.5억 원', '3억 원', '3.5억 원', '4억 원', '4.5억 원', '5억 원', '6억 원', '7억 원', '8억 원', '9억 원', '10억 원', '11억 원', '12억 원', '13억 원', '14억 원', '15억 원', '16억 원', '17억 원', '18억 원', '19억 원', '무제한'],
    form: {
      // 1 step
      saleType: 0,
      depositStep: [0, 34], // 보증금 전세
      printDepositString: '',
      monthlyStep: [0, 30], // 월세
      printMonthlyString: '',
      rentalStep: [0, 44], // 전세
      printRentalString: '',
      salePriceStep: [0, 25], // 매매
      printSaleString: '',
      // 2 step
      roomType: 0,
      roomMemo: '',
      // 3 step
      dateType: 0,
      datePicker: new Date().toISOString().substr(0, 10),
      dateMemo: '',
      // 4 step
      locType: 0,
      locSubway: '',
      locRange: 0,
      locMemo: '',
      // 5 step
      name: '',
      hp: '',
      memo: '',
      approval: false
    },
    search: {
      data: [],
      show: false,
      timer: null,
      select: ''
    },
    rules: {
      addr: [
        v => !!v || '주소지를 입력해주세요.'
      ]
    }
  }),
  created () {
    //
  },
  watch: {
    'form.locSubway': function (val, old) {
      if (val !== '') {
        if (this.search.timer != null) {
          clearTimeout(this.search.timer)
          this.search.timer = null
        }
        this.search.timer = setTimeout(() => {
          if (this.search.select !== val) {
            this.requestMapData({'type': 'searchSubway', 'text': val}).then(data => {
              if (data.array.length > 0) {
                this.search.data = data.array
                this.search.show = true
              }
            })
          }
        }, 200)
      }
    }
  },
  mounted () {
    // 창이 닫히는지 확인
    this.$store.watch(() => this.board.requestRoom.show, (newValue, oldValue) => {
      if (!newValue) {
        this.$router.replace('map')
      } else {
        //
      }
    })
  },
  components: {
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      board: state => state.board,
      config: state => state.config
    }),
    isPass: function () {
      if (this.submitLoading) {
        return false
      }
      if (this.step === 1) {
        if (this.form.saleType !== 0) { // 가격
          return true
        }
      } else if (this.step === 2) { // 방타입
        if (this.form.roomType !== 0 && !(this.form.roomType === '6' && this.form.roomMemo === '')) {
          return true
        }
      } else if (this.step === 3) { // 날짜
        if (this.form.dateType !== 0 && !(this.form.dateType === '4' && this.form.dateMemo === '')) {
          return true
        }
      } else if (this.step === 4) { // 지역
        if (this.form.locType !== 0 && !(this.form.locType === '1' && (this.form.locSubway === '' || this.form.locRange === '')) && !(this.form.locType === '2' && this.form.locMemo === '')) {
          return true
        }
      } else if (this.step === 5) { // 자세히
        if (this.form.hp !== '' && this.form.approval) {
          return true
        }
      }
      return false
    },
    printDeposit () {
      return this.depositStepText[this.form.depositStep[0]] + '~' + this.depositStepText[this.form.depositStep[1]]
    },
    printMonthly () {
      return this.monthlyStepText[this.form.monthlyStep[0]] + '~' + this.monthlyStepText[this.form.monthlyStep[1]]
    },
    printRental () {
      return this.rentalStepText[this.form.rentalStep[0]] + '~' + this.rentalStepText[this.form.rentalStep[1]]
    },
    printSalePrice () {
      return this.salePriceStepText[this.form.salePriceStep[0]] + '~' + this.salePriceStepText[this.form.salePriceStep[1]]
    }
  },
  methods: {
    ...mapActions({
      requestBoardData: 'board/requestBoardData',
      requestMapData: 'mapData/requestMapData'
    }),
    bgclick () {
      let obj = document.getElementById('subway_list_box')
      // eslint-disable-next-line no-caller
      let e = window.event || arguments.callee.caller.arguments[0]
      let eobj = e.target ? e.target : e.srcElement
      while (eobj.parentNode) {
        if (eobj === obj) {
          return false
        }
        eobj = eobj.parentNode
      }
      this.search.show = false
    },
    subwayListClick (val) {
      this.form.locSubway = val
      this.search.select = val
      this.search.show = false
    },
    // FORM
    close () {
      this.board.requestRoom.show = false
    },
    getStep () {
      return parseInt(this.step * (100 / this.maxStep))
    },
    prevPage () {
      if (this.step > 1) this.step--
      // 맵 재로드
      if (this.step === 1 && this.form.bcode !== '') {
        let _this = this
        setTimeout(function () {
          _this.$refs.postcodemap.init()
        }, 500)
      }
    },
    nextPage () {
      if (this.isPass) {
        if (this.step === this.maxStep) {
          // submit 전송
          this.submitLoading = true
          // form
          this.form.printDepositString = this.printDeposit
          this.form.printMonthlyString = this.printMonthly
          this.form.printRentalString = this.printRental
          this.form.printSaleString = this.printSalePrice
          // FormData 전송 시작
          let frm = new FormData()
          frm.append('form', encodeURI(JSON.stringify(this.form))) // qs.stringify(jsonData)
          axios.post(this.$utile.getRestUrl() + '/rep.board.request.api', frm,
            this.$utile.getAxiosConfig({ 'Content-Type': 'multipart/form-data' })
          )
            .then((response) => {
              // 응답 처리
              // console.log(response.data.array)
              if (response.data.array.rcode === '1') {
                this.close()
                this.reset()
              }
              EventBus.$emit('alert', response.data.array.msg)
              this.submitLoading = false
            })
            .catch((e) => {
              // 예외 처리
              EventBus.$emit('alert', '접수 요청에 실패하였습니다. 다시 시도 바랍니다.')
              this.submitLoading = false
            })
          //
        } else {
          this.step++
        }
      } else {
        //
      }
    },
    reset () {
      this.submitLoading = false
      this.step = 1
      // 1 step
      this.form.saleType = 0
      this.form.depositStep = [0, 34]
      this.form.deposit = [0, -1] // 보증금 전세
      this.form.monthlyStep = [0, 30]
      this.form.monthly = [0, -1] // 월세
      this.form.rentalStep = [0, 44]
      this.form.salePriceStep = [0, 25]
      this.form.salePrice = [0, -1] // 매매가
      // 2 step
      this.form.roomType = 0
      this.form.roomMemo = ''
      // 3 step
      this.form.dateType = 0
      this.form.datePicker = new Date().toISOString().substr(0, 10)
      this.form.dateMemo = ''
      // 4 step
      this.form.locType = 0
      this.form.locSubway = ''
      this.form.locRange = 0
      this.form.locMemo = ''
      // 5 step
      this.form.name = ''
      this.form.hp = ''
      this.form.memo = ''
      this.form.approval = false
    },
    onResize () {
      if (document.getElementById('item_request_modal') != null) {
        if (this.top === 0) {
          let top = (window.innerHeight / 2) - (document.getElementById('item_request_modal').clientHeight / 2)
          let left = (window.innerWidth / 2)
          this.top = top + 'px'
          this.left = left + 'px'
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/RequestRoom.vue